export default __webpack_public_path__ + "images/794e089183e1d581c363b5f947f8a60a.png";